<template>
  <div
    id="root"
    class="root"
    v-if="!item.settings.disabled || editing"
  >
    <div @click="click(index, item)">
      <span
        :ref="calculatedRef"
        class="target"
        :style="{
          width: `${item.customized.width}%`,
          height: `${item.customized.height}%`,
          left: `${item.customized.left}%`,
          top: `${item.customized.top}%`,
          position: `absolute`,
          transform: `translate(0, 0)`,
          zIndex: `${item.customized.zIndex}`,
        }"
        :index="index"
      >
        <slot></slot>
      </span>

      <Moveable
        v-if="editing && selectedItem == item"
        id="moveable"
        ref="moveable"
        :target="targetRef"
        :draggable="draggable"
        :throttleDrag="throttleDrag"
        :edgeDraggable="edgeDraggable"
        :startDragRotate="startDragRotate"
        :throttleDragRotate="throttleDragRotate"
        :resizable="resizable"
        :keepRatio="keepRatio"
        :throttleResize="throttleResize"
        :renderDirections="renderDirections"
        :rotatable="rotatable"
        :throttleRotate="throttleRotate"
        :rotationPosition="rotationPosition"
        snappable="true"
        :bounds="bounds"
        @drag="onDrag"
        @dragEnd="onDragEnd"
        @resize="onResize"
        @resizeEnd="onResizeEnd"
        @rotate="onRotate"
        @bound="onBound"
      />
    </div>
  </div>
</template>

<script>
import Moveable from "vue-moveable";
import { mapActions, mapState } from "vuex";

export default {
  components: { Moveable },

  data() {
    return {
      draggable: true,
      throttleDrag: 1,
      edgeDraggable: false,
      startDragRotate: 0,
      throttleDragRotate: 0,
      resizable: true,
      keepRatio: false,
      throttleResize: 1,
      renderDirections: ["nw", "n", "ne", "w", "e", "sw", "s", "se"],
      rotatable: true,
      throttleRotate: 0,
      rotationPosition: "top",
      bounds: { left: 0, top: 0, right: 0, bottom: 0, position: "css" },
      targetRef: null,
    };
  },

  computed: {
    ...mapState(["editing", "selectedItem"]),
    calculatedRef() {
      return `index${this.input?._id || this.input?.name}${this.index}`;
    },
  },

  props: {
    index: Number,
    input: Object,
    item: Object,
  },

  methods: {
    ...mapActions(["selectItem", "updateItem"]),

    click(index, item) {
      this.selectItem({ index, item });
    },

    calculateValues() {
      const targetElement = this.$refs.moveable;
      const parentRect = this.item.settings.show_in_exec
        ? this.$parent.$refs.ScadaPage.getBoundingClientRect()
        : this.$parent.$parent.$refs.GlobalItemsWindow.$el.getBoundingClientRect();
      const rect = targetElement.getRect();
      const width = (rect.width / parentRect.width) * 100;
      const height = (rect.height / parentRect.height) * 100;
      const left = (rect.left / parentRect.width) * 100;
      const top = (rect.top / parentRect.height) * 100;
      this.updateItem({ item: this.item, rect: { width, height, top, left } });
    },

    onDrag(e) {
      e.target.style.transform = e.transform;
    },

    onDragEnd() {
      this.calculateValues();
    },

    onResize(e) {
      e.target.style.width = `${e.width}px`;
      e.target.style.height = `${e.height}px`;
    },

    onResizeEnd(e) {
      e.target.style.width = `${e.width}px`;
      e.target.style.height = `${e.height}px`;
      this.calculateValues();
    },

    onRotate(e) {
      e.target.style.transform = e.drag.transform;
    },

    onBound(e) {
      console.log("Bound", e);
    },
  },

  async mounted() {
    this.$nextTick(() => {
      this.targetRef = this.$refs[`index${this.input?._id || this.input?.name}${this.index}`];
    });
  },
};
</script>

<style scoped>
html,
body {
  position: relative;
  height: 100%;
  margin: 0;
  padding: 0;
}

html:has(.no-relative),
body:has(.no-relative) {
  margin: 8px;
  padding: 8px;
  position: static;
  /* border: 8px solid red; */
}

html:has(.no-relative) {
  position: relative;
}

.margin .root {
  position: static;
}

.description {
  padding: 10px;
}

.container {
  position: relative;
  margin-top: 0px;
}

.will-change-container {
  padding-left: 100px;
  padding-top: 100px;
  will-change: transform;
}

.will-change-target {
  position: relative;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  z-index: 1;
  background: #ee8;
  color: #333;
  font-weight: bold;
  border: 1px solid #333;
  box-sizing: border-box;
}

.target {
  position: absolute;
  line-height: 100px;

  background: none;
  color: #333;
  font-weight: bold;
  /* border: 1px solid #333; */
  box-sizing: border-box;
}

.nested {
  position: absolute;
  border: 4px solid #ccc;
  width: 100px;
  height: 100px;
  top: 50px;
  left: 70px;
  color: #333;
  /* box-sizing: border-box; */
}

.nested.first {
  top: 150px;
}

.nested.rotate {
  transform-origin: 0 0;
  transform: rotate(-30deg);
}

.nested.scale {
  transform: scale(1.5, 1.5);
}

.nested .target {
  top: 50px;
  left: 50px;
}

/* pos guidelines */
.moveable-normal.red {
  background: red !important;
}

/* gap guidelines */
.moveable-gap.red {
  background: red !important;
}

/* When snapped to an element in elementGuidelines */
.moveable-bold.red {
  background: red !important;
}

/* A dashed line between target and element */
.moveable-dashed.red {
  border-top-color: red !important;
  border-left-color: red !important;
}

/* pos guidelines */
.moveable-normal.green {
  background: green !important;
}

/* gap guidelines */
.moveable-gap.green {
  background: green !important;
}

/* When snapped to an element in elementGuidelines */
.moveable-bold.green {
  background: green !important;
}

/* A dashed line between target and element */
.moveable-dashed.green {
  border-top-color: green !important;
  border-left-color: green !important;
}
</style>
